import React, { useMemo } from "react";

import { observer } from "mobx-react";
import PropTypes from "prop-types";
import ReactPaginate from "react-paginate";
import styled from "styled-components";

import Icon from "../../../Icon/Icon";

const StyledReactPaginate = styled(ReactPaginate)`
  margin-bottom: 0;
  padding-bottom: 1.5rem;
  border-bottom: ${({ theme }) => `${theme.primaryColor} solid 2px`};

  .selected p {
    cursor: default;
  }
`;

const StyledLabel = styled.p`
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 0;
`;

const IconLeft = <Icon color="black" icon="chevronLeft" size={28} />;
const IconRight = <Icon color="black" icon="chevronRight" size={28} />;

function ThumbnailSearchResultsPagination(props) {
  const {
    currentPage,
    handlePageClick,
    itemsPerPage,
    pageCount,
    searchResultsCount,
  } = props;

  const itemsToDisplay = itemsPerPage || 12;
  const label = useMemo(() => {
    const startCount = currentPage + 1;
    const endCount = Math.min(currentPage + itemsToDisplay, searchResultsCount);

    return (
      <StyledLabel>
        {`${startCount} - ${endCount} of ${searchResultsCount} jobs`}
      </StyledLabel>
    );
  }, [currentPage, pageCount, searchResultsCount]);

  return (
    <StyledReactPaginate
      breakLabel="..."
      className="d-flex justify-content-between list-unstyled align-items-center"
      marginPagesDisplayed={0}
      nextLabel={IconRight}
      onPageChange={handlePageClick}
      pageCount={pageCount}
      pageLabelBuilder={() => label}
      pageRangeDisplayed={0}
      previousLabel={IconLeft}
    />
  );
}

export default observer(ThumbnailSearchResultsPagination);

ThumbnailSearchResultsPagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  handlePageClick: PropTypes.func.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  searchResultsCount: PropTypes.number.isRequired,
};
